/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 27/08/2026 | Lic. José Luis Aragón Cervantes  | Tiempo de cierre de sesión a 30 minutos
* ---------------------------------------------------------------------------------------
*/

import { format, parse, parseISO } from "date-fns";
import { rxCaracteresEsp } from "../settings/regexConfig";
import moment from 'moment';

export const isErrorForm = (form) => {
    const errorValues = Object.values(form).map((x) => x.error);
    return errorValues.some((x) => x);
};

export const isNullOrEmpty = (value) => !value || value === "";

export const isNullOrEmptyNew = (value) => value === null || value === undefined || value === "";

export const getDateTimeString = (date, toLocal = false) => {
    if (toLocal) {
        return !date ? "" : format(parse(date + "Z", "yyyy-MM-dd'T'HH:mm:ssX", new Date()), "dd/MM/yyyy p");
    }

    return !date ? "" : format(parse(date, "yyyy-MM-dd'T'HH:mm:ss.S", new Date()), "dd/MM/yyyy p");
};

export const getDateTimeString2 = (date, toLocal = false) => {
    if (toLocal) {
        return !date ? "" : format(new Date(date + "Z"), "dd/MM/yyyy p");
    }

    return !date ? "" : format(new Date(date), "dd/MM/yyyy p");
};

export const getDateTimeWithSecondsString = (date, toLocal = true) => {
    if (toLocal) {
        return !date ? "" : format(parse(date + "Z", "yyyy-MM-dd'T'HH:mm:ssX", new Date()), "dd/MM/yyyy pp");
    }

    return !date ? "" : format(parse(date, "yyyy-MM-dd'T'HH:mm:ss", new Date()), "dd/MM/yyyy pp");
};

export const getDateString = (date, toLocal = true) => {
    if (!date) return "";
    try {
        // Normalizar la fecha para manejar milisegundos de menos de 3 dígitos
        let normalizedDate = date;
        const millisecondsMatch = date.match(/\.\d+/);

        if (millisecondsMatch && millisecondsMatch[0].length < 4) {
            normalizedDate = date.replace(
                /\.\d+/,
                (ms) => ms.padEnd(4, "0") // Rellena los milisegundos con ceros
            );
        }

        // Formato de entrada ajustado para manejar 'T' y milisegundos
        const dateFormat = "yyyy-MM-dd'T'HH:mm:ss.SSS";

        const parsedDate = parse(normalizedDate, dateFormat, new Date());

        // Retorna en el formato deseado
        return format(parsedDate, "dd/MM/yyyy HH:mm:ss");
    } catch (error) {
        return "Invalid date format";
    }
};

export const getDateString3 = (date, toLocal = true) => {
    if (!date) return "";
    try {
        const parsedDate = parseISO(date); // Detecta milisegundos o no
        return format(parsedDate, "dd/MM/yyyy HH:mm:ss");
    } catch (error) {
        return "Invalid date format";
    }
};

export const getDateStringV2 = (date, toLocal = true) => {
    if (toLocal) {
        return !date ? "" : format(new Date(date + "Z"), "dd/MM/yyyy");
    }

    return !date ? "" : format(new Date(date), "dd/MM/yyyy");
};

export const getDateStringV3 = (date, toLocal = true) => {
    if (toLocal) {
        return !date ? "" : format(new Date(date + "Z"), "yyyy-MM-dd");
    }

    return !date ? "" : format(new Date(date), "yyyy-MM-dd");
};

export const getTimeStringV2 = (date, toLocal = true) => {
    if (toLocal) {
        return !date ? "" : format(new Date(date + "Z"), "pp");
    }

    return !date ? "" : format(new Date(date), "pp");
};

export const getTimeString = (date) => {
    return !date ? "" : format(parse(date + "Z", "yyyy-MM-dd'T'HH:mm:ssX", new Date()), "pp");
};

export const getDateTimePost = (date) => {
    return format(date, "yyyy-MM-dd'T'HH:mm:ss");
};

export const getTimePost = () => {
    return format(new Date(), "HH:mm:ss");
};

export const getDatePost = () => {
    let date = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss");
    return date;
};

export const getMonthYearPost = (date) => {
    return format(date, "MM/yyyy");
};

export const getDateFormat = (date) => {
    return format(date, "dd/MM/yyyy");
};

export const getTimeFormat = (date) => {
    return format(date, "'T'HH:mm:ss");
};

export const getDateFilterFormat=()=>{
    let date = new Date();
    return getDatePost(date);
};

export const getDateFilterDayOneFormat=()=>{
    let date = new Date();
    date.setDate(1);
    return getDatePost(date);
};

export const getStartOfDay=()=>{
    let date = moment(new Date()).startOf('day').toDate();
    return getDateTimePost(date);
};

export const getEndOfDay=()=>{
    let date = moment(new Date()).endOf('day').toDate();
    return getDateTimePost(date);
};

export const getMoney = (value) => {
    return !value && value !== 0 ? "" : "$" + value.toLocaleString("en-EN", { minimumFractionDigits: 2 });
};

export const getNumber = (value) => {
    return !value && value !== 0 ? "" : value.toLocaleString("en-EN", { minimumFractionDigits: 0 });
};

export const getFormatoTarjeta = (value,espacios) => {
    return value.toString().padStart(espacios, '0');
};

/**
 * Valida el formato válido del identificador.
 * @param {string} Uniqueidentifier - Identificador único.
 */
export const IsValidId = (Uniqueidentifier) => {
    //^(?!.*00000000)[0-9A-Fa-f\-]{36}$
    const regex = /^(?!.*00000000)[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/gm;
    return regex.test(Uniqueidentifier);
};

export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const ValoresGenericos = {
    GUI_DEFAULT: "00000000-0000-0000-0000-000000000000",
};

export const getTimeString2 = (date) => {
    return !date ? "" : new Date(date).toLocaleTimeString("es-ES");
};
export const getDateString2 = (date) => {
    if (isNullOrEmpty(date)) {
        return "";
    }
    let day = new Date(date).getDate();
    let month = new Date(date).getMonth() + 1;
    let year = new Date(date).getFullYear();
    return `${day.toString().padStart(2, "0")}/${month.toString().padStart(2, "0")}/${year}`;
};

export const getTimeStringNuevo = (date) => {
    if (isNullOrEmpty(date)) {
        return "";
    }
    let hora = new Date(date).getHours();
    let minuto = new Date(date).getMinutes();
    return `${hora.toString().padStart(2, "0")}:${minuto.toString().padStart(2, "0")}`;
};

/**
 * Valida la longitud de una cadena.
 * @param {string} value - Texto.
 * @param {string} minLength - Longitud minima del texto.
 * @param {string} maxLength - Longitud maxima del texto.
 */
export const StringLength = (value, minLength = 1, maxLength = 1) => {
    //eslint-disable-next-line
    const regex = `/^(?!.*  )(?=.*[\w-])[\w -]{${minLength},${maxLength}}$/gm`;
    return regex.test(value);
};

/**
 * Valida cadenas alfanuméricas excluyendo los caracteres especiales.
 * @param {string} value - Texto.
 */
export const hasSpecialCharacter = (value) => {
    // eslint-disable-next-line no-useless-escape
    const regex = /[!"`#%&,: ;<>=@{ }~\$\(\)\*\+\/\\\?\[\]\^\|]+/;
    return regex.test(value);
};

/**
 * Reemplaza los parámetros basado en Template String route/{id}.
 * @param {string} template - String Templete.
 * @param {object} data - Datos a reemplazar {id:value}.
 */
export const setPathParameters = (template, data) => {
    const pattern = /{\s*(\w+?)\s*}/g; // {property}
    return template.replace(pattern, (_, token) => data[token] || "");
};

/**
 * Reemplaza los prametros basado en Template String route/:id.
 * @param {string} template - String Templete.
 * @param {object} data - Datos a reemplazar {id:value}.
 */
export const setUrlParameters = (url, params) => {
    var newObj = {};
    Object.keys(params).forEach(function (key) {
        newObj[":" + key] = params[key];
    });

    var regex = new RegExp(Object.keys(newObj).join("|"), "gi");
    return url.replace(regex, function (matched) {
        return newObj[matched];
    });
};

/**
 * Agrega AM/PM
 * @param {Date} date - Fecha.
 */

export const formatAMPM = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
};

/**
 * Genera un nuevo UUID (Universally Unique IDentifier),
 * también conocido como GUID (Globally Unique IDentifier).
 */
export const newId = () => {
    var d = new Date().getTime(); //Timestamp
    var d2 = (typeof performance !== "undefined" && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-6xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
};

/**
 * Valida si la fecha es valida en sql
 * @param {Date} date - Fecha.
 */
export const isSqlValid = function (date) {
    return date > new Date("1/1/1753 12:00:00 AM") && this < new Date("12/31/9999 11:59:59 PM");
};

export const NumberFormatUSD = (numStr) => {
    if (numStr === "") return "";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
    }).format(numStr);
};

export const NumberFormat$ = (numStr) => {
    if (numStr === "" || numStr === null || isNaN(numStr)) return "$ 0.00";
    
    const num = typeof numStr === 'string' ? parseFloat(numStr) : numStr;
    if (isNaN(num)) return "$ 0.00";
    
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
};


//Función para bus de errores tanto mainframe como context usan esta función
export const handleValidarStrings = (valor, label) =>
{
    let tError = "";
    if (valor === undefined || valor === null || valor.length === 0)  {
        tError = "Campo " + label + " requerido";
        return tError;
    }

    if(!rxCaracteresEsp.test(valor))
    {
        tError = "Caracteres no válidos";
        return tError;
    }
    return "";
};
    
export const handleValidarTelefono = (valor, label) =>
{
    let tError = "";
    if (valor === undefined || valor === null || valor.length === 0)  {
        tError = "Campo " + label + " requerido";
        return tError;
    }

    if (valor.length < 10)  {
        tError = "El campo " + label + " no debe ser menor a 10 dígitos";
        return tError;
    }

    const regex = /^[\d\s()-]+$/;
    if (!regex.test(valor)) 
    {
        tError = "El número de teléfono debe contener solo caracteres numéricos y los caracteres especiales permitidos '()'.";
        return tError;
    }
    
    if(!rxCaracteresEsp.test(valor))
    {
        tError = "Caracteres no válidos";
        return tError;
    }
    return "";
};

export const handleValidarCorreo = (valor, label) =>
{
    let tError = "";
    if (valor === undefined || valor === null || valor.length === 0)  {
        tError = "Campo " + label + " requerido";
        return tError;
    }

    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!regex.test(valor)) 
    {
        tError = "Estructura de correo no válida"
        return tError;
    }
    return "";
};

export const handleValidarNumerico = (valor, label) =>
{
    let tError = "";
    if (valor === undefined || valor === null || valor.length === 0)  {
        tError = "Campo " + label + " requerido";
        return tError;
    }

    const regex = /^\d+(\.\d{1,4})?$/;
    if (!regex.test(valor)) 
    {
        tError = "Solo caracteres numéricos permitidos y decimales"
        return tError;
    }
    return "";
};

export const handleValidarNumericoEntero = (valor, label) =>
{
    let tError = "";
    if (valor === undefined || valor === null || valor.length === 0)  {
        tError = "Campo " + label + " requerido";
        return tError;
    }

    const regex = /^\d+$/;
    if (!regex.test(valor)) {
        tError = "Solo números enteros permitidos";
        return tError;
    }
    return "";
};

export const handleValidarPorcentual = (valor, label) =>
{
    let tError = "";
    if (valor === undefined || valor === null || valor.length === 0)  {
        tError = "Campo " + label + " requerido";
        return tError;
    }

    const regex = /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/;
    if (!regex.test(valor)) 
    {
        tError = "Solo caracteres numéricos permitidos entre 0 y 1 y decimales hasta 2 dígitos ejemplo de entrada = 0.99 anteponiento al punto el cero en todo caso";
        return tError;
    }
    return "";
};

export const handleValidarHoras = (valor, label) =>
{
    let tError = "";
    if (valor === undefined || valor === null || valor.length === 0)  {
        tError = "Campo " + label + " requerido";
        return tError;
    }

    const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!regex.test(valor)) 
    {
        tError = "Solo caracteres numéricos permitidos y caracteres de formato hora hh:mm"
        return tError;
    }
    return "";
};

export const handleValidarMoney = (valor, label) =>
{
    let tError = "";
    if (valor === undefined || valor === null || valor.length === 0)  {
        tError = "Campo " + label + " requerido";
        return tError;
    }

    const regex = /^-?\d+(\.\d{1,4})?$/;
    if (!regex.test(valor)) 
    {
        tError = "Solo caracteres numéricos permitidos y decimales a 2 dígitos"
        return tError;
    }

    return "";
};


export const isDefaultDate = (date) => {
    return date.getTime() === 0;
};


/*export const ValidarNumeroEnBytes = (numero) => {


    if (byte < 1 || byte > 8) {
        return false;
    }

    const maxValor = Math.pow(2, byte * 8) - 1;
    const minValor = -(Math.pow(2, byte * 8 - 1));

    return numero >= minValor && numero <= maxValor;
};

export const byte = 1; */

export const tiempoCierreSession = 1800000; // 30 minutos

/**
 * Reproduce un mensaje de voz en español usando la Web Speech API.
 * @param {string} texto - Texto a reproducir.
 */
export const speakText = (texto) => {
    if (!texto || !window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(texto);
    utterance.lang = 'es-MX';
    utterance.rate = 1;
    utterance.pitch = 1;
    window.speechSynthesis.speak(utterance);
};
